////
/// ============================================================================
/// COMPONENT / Hamburger
/// ============================================================================
///
/// @link https://codyhouse.co/ds/components/app/animated-menu-button
/// @group components
////

export default () => {

    let menuBtn = document.querySelector('.js-o-hamburger');
    let menu = document.querySelector('.c-menu');

    if (menuBtn) {

        initMenuBtn(menuBtn);

        function initMenuBtn(btn) {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                menu.classList.toggle("open");
                btn.classList.toggle("open");

                let btnOpenSubMenu = document.querySelectorAll('.has-children');
                for (var i = 0, len = btnOpenSubMenu.length; i < len; i++) {
                    varMenuChildren[i].classList.remove('active');
                }
            });
        }
    }

    document.querySelectorAll(".c-menu li.has-children").forEach(child => {
        let wrapper = document.createElement("span");
        let btn = document.createElement("button");

        btn.classList.add('js-btn-submenu');

        btn.addEventListener("click", event => {
            event.preventDefault();
            event.target.closest("li").classList.toggle("active");
        });

        child.insertAdjacentElement("afterbegin", wrapper);
        wrapper.appendChild(child.querySelector("a"));
        wrapper.appendChild(btn);
    });


    var scrollPosition = window.scrollY;
    var logoContainer = document.querySelector('.o-header');

    window.addEventListener('scroll', function () {

        scrollPosition = window.scrollY;

        if (scrollPosition >= 30) {
            logoContainer.classList.add('scroll');
        } else {
            logoContainer.classList.remove('scroll');
        }

    });

};
